import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, ButtonGroup, Button, Form } from "react-bootstrap";
import { getSettings, updateSettings } from "../../actions/user";
import { isToggleRetainDate } from "../../actions/analyze";
import { usePermission } from "../../helpers/common";
import ChangePassword from "../settings/ChangePassword";
import Oauth from "../settings/Oauth";
// import { MAP_TYPE } from "../../constants";

const SettingsHeader = ({ children }) => {
  return (
    <Row className="header">
      <h6>{children}</h6>
    </Row>
  );
};

const SettingsBody = ({ children }) => {
  return <div className="body">{children}</div>;
};

const SettingsButtonGroup = ({
  title,
  name,
  activeKey,
  children,
  onSelect,
  disabled,
}) => {
  const childrens = React.Children.map(children, (child) => {
    if (child.props.hasOwnProperty("eventkey")) {
      return React.cloneElement(child, {
        variant:
          parseInt(activeKey) === parseInt(child.props.eventkey)
            ? "primary"
            : "default",
        onClick: () => onSelect(child.props.eventkey, name),
        disabled,
      });
    }
    return child;
  });

  return (
    <Row className="pb-3">
      <Col className="label" lg={3} md={3} sm={3}>
        {title}
      </Col>
      <Col lg={9} md={9} sm={9}>
        <ButtonGroup size="sm" toggle={true}>
          {childrens}
        </ButtonGroup>
      </Col>
    </Row>
  );
};

export class User extends Component {
  constructor() {
    super();

    this.apiKeysMap = {
      areaUnitId: "area_unit_measure_id",
      distanceUnitId: "distance_unit_measure_id",
      speedUnitId: "speed_unit_measure_id",
      weightUnitId: "weight_unit_measure_id",
      mapDisplayId: "map_display_settings_id",
      dailySummaryEmail: "daily_summary_email",
      retainLastSelectedDate: "is_retain_last_selected_date",
      chatBotId: "chat_bot_id"
    };

    this.state = {
      areaUnitId: 0,
      distanceUnitId: 0,
      speedUnitId: 0,
      weightUnitId: 0,
      mapDisplayId: 0,
      dailySummaryEmail: false,
      retainLastSelectedDate: false,
      userProperties: {},
      isModalShow: false,
      chatBotId: 0,
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.handleUserProperties = this.handleUserProperties.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  componentDidMount() {
    this.props.actions.getSettings();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.settings === null ||
      prevProps.settings === this.props.settings
    )
      return;
    const s = this.props.settings;
    const isLoadHistoryWindow = this.props.userProperties &&
      this.props.userProperties.is_load_history_window ? this.props.userProperties.is_load_history_window : false;

    // const selectedMapType = this.props.userProperties && this.props.userProperties.map_type ? this.props.userProperties.map_type : "satellite";
    // const mapTypeIndex = MAP_TYPE.indexOf(selectedMapType);

    this.setState({
      areaUnitId: s.area ? s.area.unit_measure_id : this.state.areaUnitId,
      distanceUnitId: s.distance
        ? s.distance.unit_measure_id
        : this.state.distanceUnitId,
      speedUnitId: s.speed ? s.speed.unit_measure_id : this.state.speedUnitId,
      weightUnitId: s.weight
        ? s.weight.unit_measure_id
        : this.state.weightUnitId,
      mapDisplayId: s.map_display_settings
        ? s.map_display_settings.id
        : this.state.mapDisplayId,
      dailySummaryEmail: s.hasOwnProperty("daily_summary_email")
        ? s.daily_summary_email
        : this.state.dailySummaryEmail,
      retainLastSelectedDate: s.hasOwnProperty("is_retain_last_selected_date")
        ? s.is_retain_last_selected_date
        : this.state.retainLastSelectedDate,
      chatBotId: s.chat_bot_id ? s.chat_bot_id : this.state.chatBotId,
      userProperties: { is_load_history_window: Number(isLoadHistoryWindow)/* , map_type: mapTypeIndex */ }
    });
  }

  handleSelect(key, name) {
    this.setState({ [name]: key });
    if (name && name === "retainLastSelectedDate")
      this.props.actions.isToggleRetainDate();
    if (this.apiKeysMap.hasOwnProperty(name))
      this.props.actions.updateSettings({ [this.apiKeysMap[name]]: key });
  }

  handleUserProperties(event, name) {
    this.setState({ userProperties: { [name]: event } });
    if (name === "is_load_history_window") event = !!event;
    // if (name === "map_type") event = MAP_TYPE[event];
    this.props.actions.updateSettings({ userProperties: { ...this.props.userProperties, [name]: event } });
  }

  handlePasswordChange() {
    this.setState({ isModalShow: true });
  }

  componentWillUnmount() {
    this.props.actions.getSettings();
  }

  render() {
    const allow = usePermission();
    const isAllowUserEdit = allow("user-settings", "edit");
    const isAllowFarmEdit = allow("farm-settings", "edit");

    return (
      <>
        <div className="settings animate animate__slideInUp">
          <SettingsHeader>Farm Timezone</SettingsHeader>
          <SettingsBody>{this.props.timezone}</SettingsBody>
          <SettingsHeader>Unit</SettingsHeader>
          <SettingsBody>
            <SettingsButtonGroup
              name="speedUnitId"
              title="Speed"
              activeKey={this.state.speedUnitId}
              onSelect={this.handleSelect}
              disabled={!isAllowUserEdit}
            >
              <Button eventkey={5}>MPH</Button>
              <Button eventkey={6}>KPH</Button>
            </SettingsButtonGroup>
            <SettingsButtonGroup
              name="areaUnitId"
              title="Area"
              activeKey={this.state.areaUnitId}
              onSelect={this.handleSelect}
              disabled={!isAllowUserEdit}
            >
              <Button eventkey={1}>Acres</Button>
              <Button eventkey={2}>Hectares</Button>
            </SettingsButtonGroup>
            <SettingsButtonGroup
              name="weightUnitId"
              title="Weight"
              activeKey={this.state.weightUnitId}
              onSelect={this.handleSelect}
              disabled={!isAllowUserEdit}
            >
              <Button eventkey={7}>Pounds</Button>
              <Button eventkey={10}>Sacks</Button>
              <Button eventkey={8}>Tons</Button>
              <Button eventkey={9}>Metric Tons</Button>
              <Button eventkey={11}>CWT</Button>
            </SettingsButtonGroup>
          </SettingsBody>
          <SettingsHeader>Preferences</SettingsHeader>
          <SettingsBody>
            <SettingsButtonGroup
              name="mapDisplayId"
              title="Map Icon Label"
              activeKey={this.state.mapDisplayId}
              onSelect={this.handleSelect}
              disabled={!(isAllowUserEdit && isAllowFarmEdit)}
            >
              <Button eventkey={1}>Equipment Group</Button>
              <Button eventkey={2}>Operator</Button>
            </SettingsButtonGroup>
            <SettingsButtonGroup
              name="dailySummaryEmail"
              title="Daily Summary Email"
            >
              <Form.Check
                type="switch"
                id="dailySummaryEmail"
                name="dailySummaryEmail"
                title="Daily Summary Email"
                checked={this.state.dailySummaryEmail}
                onChange={(e) =>
                  this.handleSelect(e.target.checked, "dailySummaryEmail")
                }
                disabled={!(isAllowUserEdit && isAllowFarmEdit)}
              />
            </SettingsButtonGroup>
            <SettingsButtonGroup
              name="retainLastSelectedDate"
              title="Retain Last Selected Date"
            >
              <Form.Check
                type="switch"
                id="retainLastSelectedDate"
                name="retainLastSelectedDate"
                title="Retain Last Selected Date"
                checked={this.state.retainLastSelectedDate}
                onChange={(e) =>
                  this.handleSelect(e.target.checked, "retainLastSelectedDate")
                }
                disabled={!(isAllowUserEdit && isAllowFarmEdit)}
              />
            </SettingsButtonGroup>
            <SettingsButtonGroup
              name="chatBotId"
              title="Chatbot"
              activeKey={this.state.chatBotId}
              onSelect={this.handleSelect}
              disabled={!(isAllowUserEdit && isAllowFarmEdit)}
            >
              <Button eventkey={3}>OpenAI</Button>
              <Button eventkey={4}>Gemini</Button>
            </SettingsButtonGroup>
          </SettingsBody>
          <SettingsHeader>Password</SettingsHeader>
          <SettingsBody>
            <span
              className="password"
              disabled={!isAllowUserEdit}
              onClick={this.handlePasswordChange}
            >
              Change
            </span>
          </SettingsBody>
          <SettingsHeader>Oauth</SettingsHeader>
          <SettingsBody>
            <Oauth />
          </SettingsBody>
          <SettingsHeader>Load History</SettingsHeader>
          <SettingsBody>
            <SettingsButtonGroup
              name="is_load_history_window"
              title="Load History"
              activeKey={this.state.userProperties.is_load_history_window}
              onSelect={this.handleUserProperties}
              disabled={!isAllowUserEdit}
            >
              <Button eventkey={0}>New Tab</Button>
              <Button eventkey={1}>New Window</Button>
            </SettingsButtonGroup>
          </SettingsBody>
          {/* <SettingsHeader>Map Type</SettingsHeader>
          <SettingsBody>
            <SettingsButtonGroup
              name="map_type"
              title="Map Type"
              activeKey={this.state.userProperties.map_type}
              onSelect={this.handleUserProperties}
              disabled={!isAllowUserEdit}
            >
              <Button eventkey={0}>Standard</Button>
              <Button eventkey={1}>Terrain</Button>
              <Button eventkey={2}>Satellite</Button>
              <Button eventkey={3}>Hybrid</Button>
            </SettingsButtonGroup>
          </SettingsBody> */}
        </div>
        {this.state.isModalShow && (
          <ChangePassword
            onHide={() => this.setState({ isModalShow: false })}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    { getSettings, updateSettings, isToggleRetainDate },
    dispatch
  ),
});
const mapStateToProps = (state) => ({
  settings: state.user.userSettings,
  timezone: state.farm.currentFarm.timezone,
  userProperties: state.user.userSettings.user_properties
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
